<template>
    <div class="text-body-1">
        <div class="d-table-row">
            <div class="pr-4 d-table-cell text-medium-emphasis d-flex align-center flex-nowrap">
                <v-icon size="x-small" class="mr-1">mdi-clock-outline</v-icon>{{ $t('duration') }}
            </div>
            <div class="d-table-cell">{{ info.packageDuration }} {{ $t('day', info.packageDuration) }}</div>
        </div>
        <div class="d-table-row">
            <div class="pr-4 d-table-cell text-medium-emphasis d-flex align-center flex-nowrap">
                <v-icon size="x-small" class="mr-1">mdi-calendar</v-icon>{{ $t('start_date') }}
            </div>
            <div v-if="info.packageDate" class="d-table-cell">{{ $filters.dateFormat(info.packageDate) }}</div>
        </div>
        <div class="d-table-row">
            <div class="pr-4 d-table-cell text-medium-emphasis d-flex align-center flex-nowrap">
                <v-icon size="x-small" class="mr-1">mdi-calendar</v-icon>{{ $t('end_date') }}
            </div>
            <div v-if="info.packageDate" class="d-table-cell">
                {{
                    $filters.dateFormat($dateFns.addDays($dateFns.parseISO(info.packageDate), info.packageDuration - 1))
                }}
            </div>
        </div>
        <div v-if="info.serviceName" class="d-table-row">
            <div class="pr-4 d-table-cell text-medium-emphasis d-flex align-center flex-nowrap">
                <v-icon size="x-small" class="mr-1">mdi-bed</v-icon>{{ $t('service') }}
            </div>
            <div class="d-table-cell">{{ info.serviceName }}</div>
        </div>
        <div v-if="info.secondaryServiceName" class="d-table-row">
            <div class="pr-4 d-table-cell text-medium-emphasis d-flex align-center flex-nowrap">
                <v-icon size="x-small" class="mr-1">mdi-silverware-fork-knife</v-icon>{{ $t('meal_type') }}
            </div>
            <div class="d-table-cell">{{ info.secondaryServiceName }}</div>
        </div>
        <div v-if="info.tariffName" class="d-table-row">
            <div class="pr-4 d-table-cell text-medium-emphasis d-flex align-center flex-nowrap">
                <v-icon size="x-small" class="mr-1">mdi-tag-text</v-icon>{{ $t('tariff') }}
            </div>
            <div class="d-table-cell">{{ info.tariffName }}</div>
        </div>
        <tour-additional-info v-if="packageTourInfo" :info="packageTourInfo" />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import TourAdditionalInfo from '~src/components/tours/snippets/TourAdditionalInfo.vue'

    @Component({components: {TourAdditionalInfo}})
    export class TourGeneralInfo extends Vue {
        @Prop({default: () => ({})}) info
        @Prop() packageTourInfo
    }

    export default TourGeneralInfo
</script>
